<template>
  <div class="field-body">
    <!-- eslint-disable-next-line vue/no-v-html -- trusted node body/summary from Drupal -->
    <span v-html="content" />
    <ReadMore
      :lang="lang"
      :link-url="linkUrl"
    />
  </div>
</template>

<script>
  import ReadMore from './ReadMore.vue'

  export default {
    name: 'FieldBody',
    components: {
      ReadMore,
    },
    props: {
      fieldBody: { type: Object, required: true },
      linkUrl: { type: String, default: '' },
      lang: { type: String, default: 'en' },
    },
    computed: {
      content() {
        return this.fieldBody.summary || this.fieldBody.value
      },
    },
  }
</script>

<style>
  .field-body {
    font-family: Verdana, "Lucida Sans Unicode", sans-serif;
    line-height: 1.6;
  }
  .field-body a {
    color: var(--dm-green-dark, #1c7e35);
    text-decoration: none;
  }
  .field-body a:hover {
    text-decoration: underline;
  }
</style>
